import React from "react";
import { List, Card, Button, Avatar, Icon, Popconfirm } from "antd";
const { Meta } = Card;
export function TechnicalSkillsList({
  technicalSkills,
  item,
  showModal,
  editSkill,
  deleteItem
}) {
  const confirm = index => e => {
    deleteItem(index);
  };
  return (
    <List
      grid={{
        gutter: 8,
        xs: 1,
      sm: 1,
      md: 1,
      lg: 3,
      xl: 3,
      xxl: 3,
      }}
      dataSource={[
        {},
        ...Object.keys(technicalSkills).map((el, index) => {
          return {
            ...technicalSkills[el],
            index
          };
        })
      ]}
      renderItem={item => {
        if (item && item.publicationTitle) {
          return (
            <List.Item key={item.publicationTitle}>
              <Card
                actions={[
                  <Icon type="edit" onClick={editSkill(item.publicationID)} />,
                  <Popconfirm
                    placement="bottom"
                    title="Are you sure delete this Publication?"
                    onConfirm={confirm(item.publicationID)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Icon type="delete" />
                  </Popconfirm>
                ]}
              >
                <Meta
                  avatar={
                    <Avatar src="https://assets.webiconspng.com/uploads/2017/01/Programming-Coding-Icon-300x300.png" />
                  }
                  title={item.publicationTitle}
                />

                <div
                  style={{
                    marginTop: 8
                  }}
                >
                  <Icon type="book" /> Authority : {item.publicationAuthority}{" "}
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="clock-circle" /> : {item.publicationDate}{" "}
                </div>
              </Card>
            </List.Item>
          );
        }

        return (
          <List.Item>
            <Button onClick={showModal} type="dashed" className="sdd">
              <Icon type="plus" />
              Add new publication
            </Button>
          </List.Item>
        );
      }}
    />
  );
}
